"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ecoaVisitApi = void 0;
const getEcoaVisits = {
    method: "GET",
    url: "/ecoa/visits",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const getEcoaVisitQuestionnaires = (folderId, visitId, visitSeq, crfPageId, crfPageSeq) => ({
    method: "GET",
    url: `/ecoa/visits/${folderId}/${visitId}/${visitSeq}/${crfPageId}/${crfPageSeq}/questionnaires`,
    reducer: resp => resp,
    errReducer: resp => resp,
});
exports.ecoaVisitApi = { getEcoaVisits, getEcoaVisitQuestionnaires };
//# sourceMappingURL=ecoaVisit.js.map